<template>
  <!--  직장 정보 업데이트  -->
  <div>
    <update-request-header></update-request-header>
    <update-request-info v-show="this.$store.state.BizInfo.tabValue == 0"></update-request-info>
    <update-request-agree v-show="this.$store.state.BizInfo.tabValue == 1"></update-request-agree>
    <update-request-footer props="{tabs}"></update-request-footer>
  </div>
</template>

<script>
import UpdateRequestHeader from "@/components/update/UpdateRequestHeader";
import UpdateRequestInfo from "@/components/update/UpdateRequestInfo";
import UpdateRequestAgree from "@/components/update/UpdateRequestAgree";
import UpdateRequestFooter from "@/components/update/UpdateRequestFooter";

export default {
  name: "UpdateRequest",
  components: {
    "update-request-header": UpdateRequestHeader,
    "update-request-info": UpdateRequestInfo,
    "update-request-agree": UpdateRequestAgree,
    "update-request-footer": UpdateRequestFooter,
  },

  mounted() {
    // 페이지 진입시 입력값 초기화
    this.$store.commit("BizInfo/SET_INIT");
  },
};
</script>

<style lang="" scoped></style>
